import React from 'react';
import { DocumentMarkInfo } from './printUi';

/**
 * VOID / DRAFT stamp. Drawn with a border and text colour only (no
 * background), because browsers drop background graphics when printing.
 */
export function DocumentMark({ mark }: { mark: DocumentMarkInfo }) {
  return (
    <div className="print-keep mt-3" data-mark={mark.label}>
      <p className="inline-block -rotate-3 border-4 border-red-700 px-4 py-1 text-3xl font-black tracking-[0.3em] text-red-700">{mark.label}</p>
      <p className="mt-2 font-semibold text-red-700">{mark.note}</p>
    </div>
  );
}
